export const SET_SHIPMENT_RATING_DATA = "SET_SHIPMENT_RATING_DATA";

export const setShipmentRatingData = (payload) => ({
	type: SET_SHIPMENT_RATING_DATA,
	payload,
});
